import {RuleMutable} from "./RuleMutable";
import {ICondition, IRule} from "../../../index";
import {ISelection} from "./index";
import {ConditionAntiPairs} from "./_def";
import {_} from 'lodash';
import {AvailableData} from "../mutable/rule/AvailableData";

export class RuleMutableException extends RuleMutable {
    constructor(availableData: AvailableData, selection: KnockoutObservable<ISelection | null>) {
        super(availableData, selection);
        this.isActive(true);
    }

    public override conditionFilter(condition: ICondition): boolean {
        return ['string', 'bool', 'int'].indexOf(condition.type) != -1 && !!this.getAntiPair(condition.name);
    }

    private getAntiPair(condition: string) {
        return ConditionAntiPairs.find(pair => pair.indexOf(condition) != -1);
    }

    protected override getDefinitionRule(): Partial<IRule> | Partial<IRule>[] | undefined {
        const def = this.selection()?.definition;
        switch (def?.name) {
            case 'pick_attribute_and_value': {
                const baseRule = super.getDefinitionRule();
                if (!baseRule || Array.isArray(baseRule)) {
                    return baseRule;
                }
                return _.defaults({
                    argumentoperator: this.getOppositeArgumentOperator(),
                }, baseRule);
            }
            default:
                return super.getDefinitionRule();
        }
    }

    private getOppositeArgumentOperator(): string {
        const condition = this.argumentoperator() ?? ''
        const pair = this.getAntiPair(condition)
        return pair?.find(c => c !== condition) ?? condition
    }

}